// extracted by mini-css-extract-plugin
module.exports = {"item":"ProgressionSidebarItem_item__yy7XA","active":"ProgressionSidebarItem_active__Q5QBT"};